import { forwardRef } from "react";
import { useTranslation } from "next-i18next";
import { BaseInputProps } from "@talladega/types";
import { customerValidation } from "@talladega/helpers";
import { getInputStyles, getBaseInputProps } from "../helpers";
import { BaseInput } from "../form";

// eslint-disable-next-line no-underscore-dangle
const _FirstName = forwardRef<HTMLInputElement, BaseInputProps>(
  (
    {
      type = "text",
      id = "firstName",
      disabled,
      autoComplete = "given-name",
      className,
      suppressHotjar = true,
      fieldError,
      onChange,
      ...props
    },
    ref
  ) => {
    const { t } = useTranslation(["common-components"]);
    const getFeedback = () => {
      if (!fieldError?.message) {
        if (fieldError?.type === "required") {
          return t("required");
        }
      }
      return fieldError?.message;
    };
    const baseInputProps = getBaseInputProps({
      type,
      disabled,
      label: props.label || t("common-components:first_name") || undefined,
      status: fieldError ? "error" : "default",
      feedback: getFeedback(),
      ...props,
    });
    const inputClassName = getInputStyles({
      leftIcon: baseInputProps.leftIcon,
      rightIcon: baseInputProps.rightIcon,
      border: baseInputProps.border,
      placeholderSize: baseInputProps.placeholderSize,
      status: baseInputProps.status,
    });
    return (
      <BaseInput id={id} className={className} {...baseInputProps}>
        <input
          id={id}
          className={inputClassName}
          type={type}
          autoComplete={autoComplete}
          maxLength={customerValidation.firstName.maxLength}
          label={baseInputProps.label}
          disabled={disabled}
          ref={ref}
          data-hj-allow={(!suppressHotjar && type === "text") || undefined}
          onChange={(e) => {
            e.target.value = e.target.value.trimStart();
            if (onChange) onChange(e);
          }}
          {...props}
        />
      </BaseInput>
    );
  }
);

export default _FirstName;
